<!-- <p>relatorio-votos works!</p> -->



<p align="right">
  <button class="btn btn-outline-secondary" (click)="volta()">Voltar</button>
</p>
<app-table-relatorio-email-detalhado [eleicaoId]="idEleicao" ></app-table-relatorio-email-detalhado>